import { Check, X } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

interface EditMessageActionsProps {
  isUpdatingMessage: boolean;
  onCancel: () => void;
  onReset: () => void;
  onConfirm: () => void;
}

export default function EditMessageActions({
  isUpdatingMessage,
  onCancel,
  onReset,
  onConfirm,
}: EditMessageActionsProps) {
  return (
    <div className="flex flex-row items-center gap-2">
      {/* Cancel edit changes */}
      <Button
        variant="secondary-black"
        size="sm"
        intent="iconOnly"
        aria-label="Cancel edit"
        disabled={isUpdatingMessage}
        onClick={() => {
          onCancel();
          onReset();
        }}
      >
        <X />
      </Button>

      {/* Confirm edit changes */}
      <Button
        variant="secondary-purple"
        size="sm"
        intent="iconOnly"
        aria-label="Confirm edit"
        disabled={isUpdatingMessage}
        isLoading={isUpdatingMessage}
        onClick={() => {
          onConfirm();
          onReset();
        }}
      >
        <Check />
      </Button>
    </div>
  );
}
